
          export const batfishContext = {
            selectedConfig: {
              siteBasePath: '/ekapi',
              siteOrigin: 'https://maplibre.github.io',
              hijackLinks: true,
              manageScrollRestoration: true
            },
            routes: [{
            path: '/ekapi/',
            getPage: () => import(
              /* webpackChunkName: "ekapi" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi.js'
            ),
            
            
          },{
            path: '/ekapi/api-key/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-api-key" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_api-key.js'
            ),
            
            
          },{
            path: '/ekapi/example/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example.js'
            ),
            
            
          },{
            path: '/ekapi/example/admin-map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-admin-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_admin-map.js'
            ),
            
            
          },{
            path: '/ekapi/example/city-map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-city-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_city-map.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_landscape/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-landscape" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_landscape.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_landuselv1/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-landuselv1" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_landuselv1.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_landuselv2/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-landuselv2" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_landuselv2.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_landuselv3/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-landuselv3" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_landuselv3.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_project/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-project" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_project.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_zooninglv1/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-zooninglv1" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_zooninglv1.js'
            ),
            
            
          },{
            path: '/ekapi/example/re_zooninglv2/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-re-zooninglv2" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_re_zooninglv2.js'
            ),
            
            
          },{
            path: '/ekapi/example/road-map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-road-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_road-map.js'
            ),
            
            
          },{
            path: '/ekapi/example/terrain-map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-terrain-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_terrain-map.js'
            ),
            
            
          },{
            path: '/ekapi/example/vietnam-map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-example-vietnam-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_example_vietnam-map.js'
            ),
            
            
          },{
            path: '/ekapi/examples/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-examples" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_examples.js'
            ),
            
            
          },{
            path: '/ekapi/overview/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-overview" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_overview.js'
            ),
            
            
          },{
            path: '/ekapi/rest/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest.js'
            ),
            
            
          },{
            path: '/ekapi/rest/direction_osm/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-direction-osm" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_direction_osm.js'
            ),
            
            
          },{
            path: '/ekapi/rest/geocoding/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-geocoding" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_geocoding.js'
            ),
            
            
          },{
            path: '/ekapi/rest/isoschrone_osm/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-isoschrone-osm" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_isoschrone_osm.js'
            ),
            
            
          },{
            path: '/ekapi/rest/lrs/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-lrs" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_lrs.js'
            ),
            
            
          },{
            path: '/ekapi/rest/map/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-map" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_map.js'
            ),
            
            
          },{
            path: '/ekapi/rest/matrix_osm/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-matrix-osm" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_matrix_osm.js'
            ),
            
            
          },{
            path: '/ekapi/rest/parcel/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-parcel" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_parcel.js'
            ),
            
            
          },{
            path: '/ekapi/rest/place/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-place" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_place.js'
            ),
            
            
          },{
            path: '/ekapi/rest/power_meter/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-power-meter" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_power_meter.js'
            ),
            
            
          },{
            path: '/ekapi/rest/realestate/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-realestate" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_realestate.js'
            ),
            
            
          },{
            path: '/ekapi/rest/water_meter/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-rest-water-meter" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_rest_water_meter.js'
            ),
            
            
          },{
            path: '/ekapi/restv2/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-restv2" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_restv2.js'
            ),
            
            
          },{
            path: '/ekapi/restv2/osm/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-restv2-osm" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_restv2_osm.js'
            ),
            
            
          },{
            path: '/ekapi/restv2/poi/',
            getPage: () => import(
              /* webpackChunkName: "ekapi-restv2-poi" */
              '/home/duongnv/ekapi-docs/_batfish_tmp/_ekapi_restv2_poi.js'
            ),
            
            
          }],
            notFoundRoute: {
      path: '',
      getPage: () => { throw new Error('No matching route.'); },
      is404: true
    }
          };